import { PackageCheck, Milestone, LucideProps } from 'lucide-react';
import React from 'react';

const PackageMilestone = React.forwardRef<SVGSVGElement, LucideProps>((props, ref) => {
     return (
  <svg width="24" height="24" viewBox="0 0 48 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>
    <g transform="scale(2)">
      <g transform="translate(13, 4) scale(0.5)">
        <PackageCheck size={24} strokeWidth={2} />
      </g>
      <g transform="translate(0, -7) scale(0.8)">
        <Milestone size={24} strokeWidth={2} />
      </g>
    </g>
  </svg>
);
});

export default PackageMilestone;